import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/components/auth/AuthContext";
import { supabase } from "@/lib/supabase";
import { Bot, BarChart2 } from "lucide-react";
import { ChangePasswordModal } from "@/components/auth/ChangePasswordModal";

export function Header() {
  const { user, logout } = useAuth();
  const [title, setTitle] = useState("Sistema de Gestión de Moda");
  const [showBot, setShowBot] = useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  useEffect(() => {
    loadSettings();
  }, []);

  const loadSettings = async () => {
    try {
      const { data, error } = await supabase
        .from('app_settings')
        .select('title, n8n_settings')
        .not('n8n_settings', 'is', null)
        .limit(1);

      if (error) throw error;
      
      if (data && data.length > 0) {
        setTitle(data[0].title);
        document.title = data[0].title;
        
        // Verificar si hay configuración de n8n
        const n8nConfig = data[0].n8n_settings;
        const hasN8nConfig = n8nConfig && 
                           n8nConfig.n8n_url && 
                           n8nConfig.n8n_webhook && 
                           n8nConfig.n8n_api_key;
        
        setShowBot(hasN8nConfig);
      }
    } catch (error) {
      console.error('Error loading settings:', error);
    }
  };

  return (
    <header className="header-gradient shadow-lg">
      <div className="container mx-auto p-4 flex justify-between items-center">
        <h1 className="text-2xl font-bold text-white">{title}</h1>
        {user && (
          <div className="flex items-center gap-4">
            {showBot && (
              <Button
                variant="default"
                size="icon"
                onClick={() => window.location.hash = "#/chat"}
                className="bg-white text-gray-900 hover:bg-gray-100"
              >
                <Bot className="h-5 w-5" />
              </Button>
            )}
            <Button
              variant="default"
              onClick={() => window.location.hash = "#/informes"}
              className="bg-white text-gray-900 hover:bg-gray-100"
            >
              <BarChart2 className="h-5 w-5 mr-2" />
              Informes
            </Button>
            <span className="text-sm text-white">
              {user.name} ({user.role})
            </span>
            <Button
              variant="default"
              onClick={() => setShowChangePassword(true)}
              className="bg-white text-gray-900 hover:bg-gray-100"
            >
              Cambiar contraseña
            </Button>
            <Button 
              variant="default" 
              onClick={logout}
              className="bg-white text-gray-900 hover:bg-gray-100"
            >
              Cerrar Sesión
            </Button>
            <ChangePasswordModal open={showChangePassword} onClose={() => setShowChangePassword(false)} userEmail={user.username} />
          </div>
        )}
      </div>
    </header>
  );
}
